import React, { useEffect, useState } from "react";
import { FaWhatsapp } from "react-icons/fa";
import { MdArrowUpward } from "react-icons/md";
import "./floating.css";
import { useSettings } from "../SettingsContext";

const FloatingWidgets = () => {
  const { settings } = useSettings(); // 👈 نجيب الـ settings من الـ context
  const [scrollPercent, setScrollPercent] = useState(0);

  // calculate scroll percentage
  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight =
        document.documentElement.scrollHeight - window.innerHeight;
      const scrolled = (scrollTop / docHeight) * 100;
      setScrollPercent(Math.round(scrolled));
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // scroll to top
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      {/* WhatsApp Icon - Left */}
      {settings?.phone && (
        <a
          href={`https://wa.me/${settings.phone}`}
          target="_blank"
          rel="noreferrer"
          className="whatsapp-float"
        >
          <FaWhatsapp />
        </a>
      )}

      {/* Scroll Indicator - Right */}
      <div className="scroll-indicator" onClick={scrollToTop}>
        {scrollPercent < 100 ? (
          <span className="percent">{scrollPercent}%</span>
        ) : (
          <MdArrowUpward className="arrow" />
        )}
      </div>
    </>
  );
};

export default FloatingWidgets;
